module.exports = __webpack_public_path__ + "img/logo.fd4c924a.png";